import { useQuery } from '@tanstack/react-query'
import { getAlertSettings } from 'services/apiAlert'

const useGetAlertUiData = () => {
  const {isPending,isError,data: alertUiData} = useQuery({
    queryKey:['alertUiData'],
    queryFn: getAlertSettings,
    keepPreviousData: true,
    staleTime: 2 * 60 * 60 * 1000,
    
  })

  return {isPending,isError,alertUiData}
}

export default useGetAlertUiData
